export default [
  {
    label: "Visa",
    value: "Visa",
  },
  {
    label: "MasterCard",
    value: "MasterCard",
  },
  {
    label: "MpesaSTK",
    value: "MpesaSTK",
  },
  {
    label: "MpesaPayBill",
    value: "MpesaPayBill",
  },
  {
    label: "MpesaTill",
    value: "MpesaTill",
  },
  {
    label: "AirtelSTK",
    value: "AirtelSTK",
  },
  {
    label: "AirtelPayBill",
    value: "AirtelPayBill",
  },
  {
    label: "AirtelTill",
    value: "AirtelTill",
  },
];
